import { useMutation } from 'react-query'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router'
import decodeJwt from 'jwt-decode'
import { ACCESS_TOKEN_KEY } from '../../constants/common'
import { contractCheck, logoutCall, signinCall } from './AuthForm-api'
import { Credencials, TokenAnswer } from './AuthForm-types'
import {
  getPermissions,
  LSClear,
  setPermissions,
  setToken,
  setUserName,
} from '../../utils/storage'
import { ROLE_CONSUMER } from '../../constants/roles'
import { authDataResetAction, authDataSetAction } from './AuthForm-actions'
import { toast } from 'react-toastify'
import { MAIN_PATH } from '../../constants/globalConstants'

export const useAuth = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const mutation = useMutation(
    (credencials: Credencials) => signinCall(credencials),
    {
      onSuccess: async (data: TokenAnswer, variables: Credencials) => {
        const jwtToken = data[ACCESS_TOKEN_KEY]
        if (ACCESS_TOKEN_KEY in data) {
          const decodedToken: any = decodeJwt(jwtToken)
          setToken(jwtToken)
          setPermissions(decodedToken.role)
        }
        const permissions = getPermissions()
        if (permissions !== ROLE_CONSUMER) {
          throw new Error('Недостаточно прав')
        }
        setUserName(variables.username)
        dispatch(
          authDataSetAction({
            permissions,
            username: variables.username,
            token: jwtToken,
          })
        )
        contractCheck()
        navigate(-1)
      },
    }
  )
  return mutation
}

export const useLogout = () => {
  // const client = useQueryClient()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const mutation = useMutation(() => logoutCall(), {
    onSuccess: async () => {
      dispatch(authDataResetAction())
      navigate(MAIN_PATH)
      LSClear()
      // client.clear()
    },
    onError: (error: Error) => {
      toast.error(error?.message ?? 'Не удалось выйти')
    },
  })
  return mutation
}
